var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMincAdminInactive = function SvgMincAdminInactive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "5.-Health-Screening",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.13.1-Reports---default",
    transform: "translate(-16.000000, -622.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(16.000000, 622.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,2.99999996 C8.03745228,2.99999996 6.60640509,4.54372803 6.75131707,6.53626783 C6.88897752,8.42704307 8.33790241,9.99999996 10,9.99999996 C11.6612284,9.99999996 13.1084266,8.42794587 13.2486313,6.53697056 C13.3946266,4.56603384 11.9534215,2.99999996 10,2.99999996 Z M10,3.99999996 C11.369948,3.99999996 12.3545637,5.06989727 12.2513661,6.46306414 C12.1476012,7.86256667 11.1005053,8.99999996 10,8.99999996 C8.89865594,8.99999996 7.85049386,7.86211229 7.74868004,6.4636929 C7.64585161,5.04980204 8.6190258,3.99999996 10,3.99999996 Z M10,11 C8.51810959,11 7.05862153,11.4157291 5.90025544,12.1878628 C4.63412367,13.0318301 3.78750562,14.2547745 3.51918863,15.7425052 C3.40273603,16.3880191 3.8216013,17 4.49999997,17 L15.5,17 C16.1785996,17 16.5975932,16.388112 16.4811196,15.7424815 C16.2126356,14.2547352 15.3659317,13.0318108 14.0997768,12.1878583 C12.9413713,11.4157259 11.4818836,11 10,11 Z M10,12 C11.2898862,12 12.5560068,12.3606465 13.5451452,13.0199543 C14.5921552,13.7178363 15.2784831,14.7091239 15.4970107,15.9200475 L15.4982529,15.9276422 C15.5026449,15.9575995 15.5002285,15.9823936 15.4950628,15.998297 L15.4944241,16 L4.50583027,16 L4.5052602,15.9983607 C4.49965456,15.9811043 4.49728314,15.9534098 4.50330702,15.9200186 C4.7217006,14.709097 5.40793561,13.7178267 6.45490076,13.0199497 C7.44399489,12.3606478 8.71011072,12 10,12 Z",
    id: "Combined-Shape",
    fill: "currentColor",
    mask: "url(#mask-2)"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMincAdminInactive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/minc-admin-inactive.7e2ca81c.svg";
export { ForwardRef as ReactComponent };